import { render, staticRenderFns } from "./VSelectInput.vue?vue&type=template&id=f2482674&scoped=true"
import script from "./VSelectInput.vue?vue&type=script&lang=js"
export * from "./VSelectInput.vue?vue&type=script&lang=js"
import style0 from "./VSelectInput.vue?vue&type=style&index=0&id=f2482674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2482674",
  null
  
)

export default component.exports